import container from '@/container';
import { WindowsServiceContract, CONTRACTS } from '@/core/contracts';
import FileUploader from './FileUploader.vue';

export function showFileUploader() {
    const windowsService = container.get<WindowsServiceContract>(CONTRACTS.WindowsService);
    windowsService.showModalComponent(FileUploader);
}
